// extracted by mini-css-extract-plugin
module.exports = {"table":"OrderTable-module_table_2iOv4","thead":"OrderTable-module_thead_brKHZ","tr":"OrderTable-module_tr_1KfxO","label":"OrderTable-module_label_17qwG"};